import React from "react";

type HeaderBalanceProps = {
    isCreditLoading: boolean;
    isCreditError: boolean;
    balanceWithoutVAT: string;
    credit: {
        credit: number;
    };
    t: (key: string) => string;
}

const HeaderBalance = ({
    isCreditLoading,
    isCreditError,
    balanceWithoutVAT,
    credit,
    t
}: HeaderBalanceProps) => {
  if (!isCreditLoading && !isCreditError) {
    return (
        <div className="d-none d-lg-flex ms-2 flex-column">
        <div className="mb-1 mt-2">
          <h6 className="mb-0">{t("Balance")}</h6>
        </div>
        <div className="d-flex">
          <div className="me-4">
            <p className="text-muted mb-0 small">{t("without VAT")}</p>
            
            <h6 className="mb-0">{`€ ${balanceWithoutVAT}`}</h6>
          </div>
          <div>
            <p className="text-muted mb-0 small">{t("with VAT")}</p>
            <h6 className="mb-0">{`€ ${credit?.credit}`}</h6>
          </div>
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default HeaderBalance;